/* Sinjef Smooth Scroll — Lenis + barra de progreso + reveal (v2 optimizada rendimiento)
   Cambios v2: loop rAF condicional (solo procesa con scroll reciente), observer con
   throttle, reveal con IO barato, sin getComputedStyle repetido. */
(function () {
  if (window.SinjefSmoothScroll) return;
  window.SinjefSmoothScroll = true;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  // ---------- Lenis ----------
  var lenis = null;
  if (!prefersReduced && window.Lenis && !isMobile) {
    lenis = new Lenis({
      duration: 1.15,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      touchMultiplier: 1.5,
      autoRaf: false, // loop manual condicional (menos CPU cuando no scrollea)
    });
    window.__lenis = lenis;

    // Loop rAF que SOLO procesa cuando hubo scroll/interacción reciente (<250ms)
    var lastActivity = 0;
    function onActivity() { lastActivity = performance.now(); }
    window.addEventListener('wheel', onActivity, { passive: true });
    window.addEventListener('touchstart', onActivity, { passive: true });
    window.addEventListener('keydown', onActivity, { passive: true });

    function rafLoop(time) {
      if (performance.now() - lastActivity < 250 || lenis.isScrolling) {
        lenis.raf(time);
      }
      requestAnimationFrame(rafLoop);
    }
    requestAnimationFrame(rafLoop);
    lastActivity = performance.now();

    // Anchors
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var target = document.querySelector(a.getAttribute('href'));
      if (target && lenis) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -90, duration: 1.2 });
      }
    });

    // Pausar/reanudar con modales — con throttle para no llamar getComputedStyle en cada mutation
    var lockedCache = null;
    function computeLocked() {
      return (
        document.querySelector('dialog[open]') !== null ||
        getComputedStyle(document.body).overflowY === 'hidden' ||
        getComputedStyle(document.documentElement).overflowY === 'hidden'
      );
    }
    function syncLenisState() {
      if (!lenis) return;
      var locked = computeLocked();
      if (locked !== lockedCache) {
        lockedCache = locked;
        if (locked && lenis.isRunning) lenis.stop();
        else if (!locked && lenis.isStopped) lenis.start();
      }
    }
    var syncTimer = null;
    function throttledSync() {
      if (syncTimer) return;
      syncTimer = setTimeout(function () { syncTimer = null; syncLenisState(); }, 120);
    }
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(throttledSync).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'open'],
      });
    }
    window.addEventListener('resize', throttledSync);
    setTimeout(syncLenisState, 500);
  }

  // ---------- Barra de progreso (rAF coalescido, solo en scroll) ----------
  var barWrap = document.createElement('div');
  barWrap.className = 'sinjef-scroll-progress';
  barWrap.setAttribute('aria-hidden', 'true');
  var bar = document.createElement('div');
  bar.className = 'sinjef-scroll-progress__bar';
  barWrap.appendChild(bar);
  document.body.appendChild(barWrap);

  var ticking = false;
  function updateProgress() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
    bar.style.width = pct.toFixed(2) + '%';
    barWrap.classList.toggle('is-visible', window.scrollY > 40);
    ticking = false;
  }
  function requestTick() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    }
  }
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });
  updateProgress();

  // ---------- Reveal (IntersectionObserver, se auto-destruye) ----------
  if (!prefersReduced && 'IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll(
      '#MainContent > .shopify-section, main .shopify-section'
    );
    if (revealEls.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );
      revealEls.forEach(function (el) {
        if (el.closest('.header-group') || el.closest('header')) return;
        el.classList.add('sinjef-reveal');
        observer.observe(el);
      });
    }
  }
})();
